import { FC, PropsWithChildren, useId } from "react";

import Stack from "@mui/material/Stack";

import { DashboardDivider } from "@/dashboard-design-system/Divider/DashboardDivider";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface TranslationSectionProps {
  title: string;
}

export const TranslationSection: FC<PropsWithChildren<TranslationSectionProps>> = ({ title, children }) => {
  const titleId = useId();

  return (
    <Stack
      component="section"
      aria-labelledby={titleId}
      gap={2}
      sx={(theme) => ({
        width: "100%",
        minWidth: 0,
        "& .MuiInputBase-root:not(.MuiInputBase-multiline)": { height: theme.spacing(4.5) },
        "& input.MuiInputBase-input": { padding: theme.spacing(0.5, 1), height: "100%", boxSizing: "border-box" },
        '& [data-lexical-editor="true"]': {
          ...theme.typography.body2,
          color: theme.palette.text.neutral.moderate,
          minHeight: theme.spacing(9.625),
          padding: theme.spacing(1, 2),
        },
      })}
    >
      <Stack direction="row" alignItems="center" gap={2}>
        <DashboardTypography
          component="h3"
          id={titleId}
          variant="subtitle2"
          vibe="text-neutral-quiet"
          sx={{ textTransform: "uppercase" }}
        >
          {title}
        </DashboardTypography>
        <DashboardDivider sx={{ flex: 1 }} />
      </Stack>
      {children}
    </Stack>
  );
};
